import { HTTP } from '@/axios_api/http-common' 
import {Activity} from '../../types/Activity'
import store from "@/store/index"
import Vue from 'vue'
import Milestone from './Milestone'

const state = {
  activityChanges:[],
  updateRoute:false,
  activeActivityId:"",
  canSaveActivity: true,
  activities: [],
}

interface IState {
    activityChanges:Array<any>,
    updateRoute:boolean,
    activeActivityId:string,
    canSaveActivity: boolean,
    activities: Array<any>,
}

const getters = {

  getActivitiesForProject : (state: IState,getters:any,rootState:any,rootGetters:any) => (projectId:string) => {
    return rootGetters["projectModule/getProjectById"](projectId).activities
  },

  getNewActivitiesForProject : (state: IState,getters:any,rootState:any,rootGetters:any) => (projectId:string) => {
    return state.activities
  },

  allActivities: (state: IState, getters: any, rootState: any, rootGetters: any) => (projectId: string) => {
    const project = rootGetters["projectModule/getProjectById"](projectId);
    return project ? project.activities : [];
  },

  getActivityById: (state: IState,getters:any,rootState:any,rootGetters:any) => (activityId:string) => {
    for(let key in rootState.projectModule.projects){
      for(let i=0;i<rootState.projectModule.projects[key].length;i++){
        let currentActivity = rootState.projectModule.projects[key][i].activities.find((a:any) => a.id == activityId)
        if(currentActivity){
          currentActivity.sequenceId = key
          currentActivity.projectId = rootState.projectModule.projects[key][i].id
          return currentActivity
        }
      }
    }
    return undefined
  },

  getActivityChangesCount: (state:IState) => {
    return state.activityChanges.length
  },

  getActivitySaveStatus: (state:IState) => {
    return state.canSaveActivity;
  },

  convertActivityToActivityModel: (state: IState,getters:any) => (activityToConvertId:any) => {
    
    let activityToConvert = getters.getActivityById(activityToConvertId)
    let activityModel:any = {}
    
    activityModel.id = activityToConvert.id
    activityModel.sequenceId = activityToConvert.sequenceId
    activityModel.projectId = activityToConvert.projectId
    activityModel.name = activityToConvert.name
    activityModel.start = activityToConvert.start
    activityModel.end = activityToConvert.end
    activityModel.departmentId = activityToConvert.departmentId
    activityModel.wellActivityId = activityToConvert.wellActivity?activityToConvert.wellActivity.id:-1
    activityModel.budgetId = activityToConvert.Budget?activityToConvert.Budget.id:-1
    activityModel.activityDependencyId = activityToConvert.activityDependencyId?activityToConvert.activityDependencyId:-1
    activityModel.operationUnitId = activityToConvert.operationUnitId
    activityModel.isRigMove = activityToConvert.isRigMove

    activityModel.selectedCost = activityToConvert.selectedCost || null;
    
    //handle budget updates here
    if(activityToConvert.budgetChanged){
      activityModel.budget = {
        budgetTemplateId:activityToConvert.budget.budgetTemplateId,
        activityId:activityToConvert.budget.activityId,
        budgetLines:activityToConvert.budget.budgetLines.filter((bl:any)=>bl.lineItemId!=null).map((bl:any) => ({
          lineItemId:bl.lineItemId,
          lineValue:bl.lineValue
        }))
      }
    }

    if(activityToConvert.actualBudgetChanged){
      activityModel.actualCost = {
        budgetTemplateId:activityToConvert.budget.budgetTemplateId,
        activityId:activityToConvert.actualCost.activityId,
        budgetLines:activityToConvert.actualCost.budgetLines.filter((bl:any)=>bl.lineItemId!=null).map((bl:any) => ({
          lineItemId:bl.lineItemId,
          lineValue:bl.lineValue
        }))
      }
    }
    //end of budget update

    return activityModel

  },

  getActiveActivity:(state: IState,getters:any) => {
    return getters.getActivityById(state.activeActivityId)
  },

  getActivitySelectedCost: (state: IState, getters: any) => (activityId: any) => {
    const activity = getters.getActivityById(activityId);
    return activity ? activity.selectedCost : null;
  },

}

const mutations = {

  addActivity(state:IState,activityToAddId:any){ 

    if(store.getters.activeUser.permissions.includes("wellplanner")){
      state.activityChanges.push({
        id:activityToAddId,
        action:"CREATE"
      })
     }

  },

  updateActivity (state:IState, activityUpdateId:any) {
    //record the change that just happened
    let existingChangeIndex = state.activityChanges.findIndex(thisActivityUpdate => thisActivityUpdate.id == activityUpdateId)
    if(existingChangeIndex<0){  

      if(store.getters.activeUser.permissions.includes("wellplanner")){
        state.activityChanges.push({
          id:activityUpdateId,
          action:"UPDATE",
        })
       }
    }
  },

  deleteActivity(state: IState, activityToDeleteId: any) {
    let existingChangeIndex = state.activityChanges.findIndex(thisActivityUpdate => thisActivityUpdate.id == activityToDeleteId)
    
    if(existingChangeIndex>-1){
        if(state.activityChanges[existingChangeIndex].action=="CREATE"){
            state.activityChanges.splice(existingChangeIndex,1)
        }else{
            state.activityChanges[existingChangeIndex].action = "DELETE"
        }
    }
    else{
     if(store.getters.activeUser.permissions.includes("wellplanner")){
        state.activityChanges.push({
          id:activityToDeleteId,
          action:"DELETE",
      })
       }
    }
  },

  setActiveActivity(state:IState,activityId:string){
    state.activeActivityId = activityId
  },

  resetUpdateRouter(state:IState){
    state.updateRoute = false
  },

  clearActivityChanges(state:IState,data:any){
    state.activityChanges = []
  },

  setActivities(state: IState, { projectId, activities }: { projectId: string; activities: any[] }) {
    const project = store.getters["projectModule/getProjectById"](projectId);
    if (project) {
      project.activities = activities;
    }
  },

  setActivities2(state: IState, { activities }: { activities: any[] }) {
    state.activities = activities;
  },
}
const actions = {

  //persisting view create operation
  addActivity({commit,state,rootState}:{commit:any, state:IState,rootState:any},payload:any){
    let tempId = Math.abs((Math.floor(Math.random() * (10 - +4000))  +10)+(Math.floor(Math.random() * (10 - +4000))  +10)); 
    payload.newActivity.id = tempId
    rootState.projectModule.projects[payload.sequenceId][payload.projectIndex].activities.push(payload.newActivity)
    
    if (payload.newActivity.wellActivity.id === -1) {
        state.canSaveActivity = false;
    }
    else {
      state.canSaveActivity = true;
    }
    commit('addActivity',tempId)
  },

  //persisting view update operation
  updateActivity({ commit, state, rootState }: { commit: any, state: IState, rootState: any }, activityUpdate: any) {
    // Check if the project sequence and project index exist
    const sequenceProjects = rootState.projectModule.projects[activityUpdate.sequenceId];
    if (!sequenceProjects) {
        return;
    }

    const project = sequenceProjects[activityUpdate.projectIndex];
    if (!project) {
        return;
    }

    const existsingActivityIndex = project.activities.findIndex(
        (thisActivity: any) => thisActivity.id == activityUpdate.id
    );

    if (existsingActivityIndex === -1) {
        return;
    }

    // Update the existing activity with new values
    for (let key in activityUpdate) {
        if (key === "id" || key === "sequenceId" || key === "projectIndex") continue;
        project.activities[existsingActivityIndex][key] = activityUpdate[key];
    }

    if (activityUpdate.wellActivity && activityUpdate.wellActivity.id === -1) {
        state.canSaveActivity = false;
    }
    else {
        state.canSaveActivity = true;
    }

    // Commit the update
    commit("updateActivity", activityUpdate.id);
},

  //persisting view delete
  deleteActivity({commit,state,rootState}:{commit:any, state:IState,rootState:any},payload:any){
    let existsingActivityIndex = rootState.projectModule.projects[payload.sequenceId][payload.projectIndex].activities.findIndex((thisActivity :any)=> thisActivity.id == payload.id)
    rootState.projectModule.projects[payload.sequenceId][payload.projectIndex].activities.splice(existsingActivityIndex,1);
    state.canSaveActivity = true;
    commit("deleteActivity",payload.id)
  },

  updateActivityBudget({commit,state,rootState}:{commit:any, state:IState,rootState:any},budgetUpdate:any){
    let existsingActivityIndex = rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities.findIndex((thisActivity :any)=> thisActivity.id == budgetUpdate.id)
    rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].budgetChanged = true
    let currentBudget = rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].budget
    
    if(currentBudget==null){
      currentBudget = {budgetTemplateId:"",budgetLines:[],activityId:budgetUpdate.id}
      Vue.set(rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex],'budget',currentBudget)
    }
    
    for(let key in budgetUpdate){
      //skip the other keys that came with the budget update object
      if(key == "id"||key=="sequenceId"||key=="projectIndex")continue
      //treat budget line items here, 
      if(key=="lineItem"){
        //Look for the budgetLineIndex
        let budgetLineIndex = currentBudget.budgetLines.findIndex((thisBudgetLine:any) => thisBudgetLine.lineItemId == budgetUpdate.lineItem.lineItemId)
        //where the budget lineitem is not found, do a push into budget lines
        if(budgetLineIndex<0){
          rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].budget.budgetLines.push({lineValue:budgetUpdate.lineItem.lineValue,lineItemId:budgetUpdate.lineItem.lineItemId})
        }else{
          //where the budget line is found, do an update of that particular budget line
          rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].budget.budgetLines[budgetLineIndex].lineValue = budgetUpdate.lineItem.lineValue
        }
      }else{
        //Handle NON budget line updates here
        if(key == "budgetTemplateId"){
          //clearing the budget lines when templates are changed
          rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].budget.budgetLines = []
          if( rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost){
            rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost.budgetLines = []
          }
        }
        rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].budget[key] = budgetUpdate[key]
      }
    }

    if(store.getters.activeUser.permissions.includes("budgetentry")){
      commit("updateActivity",budgetUpdate.id)
     }
  },

  updateActivityActualBudget({commit,state,rootState}:{commit:any, state:IState,rootState:any},budgetUpdate:any){
    let existsingActivityIndex = rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities.findIndex((thisActivity :any)=> thisActivity.id == budgetUpdate.id)
    rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualBudgetChanged = true
    let currentBudget = rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost
    
    if(currentBudget==null){
      currentBudget = {budgetTemplateId:"",budgetLines:[],activityId:budgetUpdate.id}
      Vue.set(rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex],'actualCost',currentBudget)
    }
    
    for(let key in budgetUpdate){
      //skip the other keys that came with the budget update object
      if(key == "id"||key=="sequenceId"||key=="projectIndex")continue
      //treat budget line items here, 
      if(key=="lineItem"){
        //Look for the budgetLineIndex
        let budgetLineIndex = currentBudget.budgetLines.findIndex((thisBudgetLine:any) => thisBudgetLine.lineItemId == budgetUpdate.lineItem.lineItemId)
        //where the budget lineitem is not found, do a push into budget lines
        if(budgetLineIndex<0){
          rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost.budgetLines.push({lineValue:budgetUpdate.lineItem.lineValue,lineItemId:budgetUpdate.lineItem.lineItemId})
        }else{
          //where the budget line is found, do an update of that particular budget line
          rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost.budgetLines[budgetLineIndex].lineValue = budgetUpdate.lineItem.lineValue
        }
      }else{
        //Handle NON budget line updates here
        if(key == "budgetTemplateId"){
          //clearing the budget lines when templates are changed
          rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost.budgetLines = []
        }
        rootState.projectModule.projects[budgetUpdate.sequenceId][budgetUpdate.projectIndex].activities[existsingActivityIndex].actualCost[key] = budgetUpdate[key]
      }
    }
    commit("updateActivity",budgetUpdate.id)
  },

  updateActivitySelectedCost({ commit, state, rootState }:{commit: any, state: IState, rootState: any}, payload: any) {
    // Locate the activity in the store
    const existingActivityIndex = rootState.projectModule.projects[payload.sequenceId][payload.projectIndex].activities.findIndex(
      (activity: any) => activity.id === payload.id
    );
  
    if (existingActivityIndex === -1) {
      return;
    }
  
    // Update the selectedCost for the activity
    rootState.projectModule.projects[payload.sequenceId][payload.projectIndex].activities[
      existingActivityIndex
    ].selectedCost = payload.selectedCost;
  
    // Commit the change to track it
    commit("updateActivity", payload.id);
  },  

  //post server operations
  updateNewActivities({commit,state,rootState}:{commit:any, state:IState,rootState:any},payload:any){
    rootState.projectModule.projects[payload.sequenceId].forEach((thisProject:any,projectIndex:number) => {
      thisProject.activities.forEach((thisActivity:any,index:number,activities:Array<any>) => {
        if (payload.data) {
          let indexOfUpdate = payload.data.findIndex((thisUpdate:any) => thisUpdate.data.tempKey == thisActivity.id)
          if(indexOfUpdate>-1)Vue.set(rootState.projectModule.projects[payload.sequenceId][projectIndex].activities,index,payload.data[indexOfUpdate].data)
        }
      })
    })
  },

  updateActivities({commit,state,rootState}:{commit:any, state:IState,rootState:any},payload:any){
    rootState.projectModule.projects[payload.sequenceId].forEach((thisProject:any,projectIndex:any) => {
      thisProject.activities.forEach((thisActivity:any,index:number,activities:Array<any>) => {
        if (payload.data) {
          let indexOfUpdate = payload.data.findIndex((thisUpdate:any) => thisUpdate.data.id == thisActivity.id)
          if(indexOfUpdate>-1)Vue.set(rootState.projectModule.projects[payload.sequenceId][projectIndex].activities,index,payload.data[indexOfUpdate].data)
        }
        })
    })
  },

  createActivitiesOnServer({dispatch,commit}:{dispatch:any,commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.activities.length>0){
            HTTP.post('activities/create',data)
            .then((response:any) => {
                dispatch('updateNewActivities',{sequenceId:data.sequenceId,data:response.data.data})
                if (response.data.data) {
                  let tempActualKeyPairs = response.data.data.map((thisActivity:any) => {return {id:thisActivity.data.id,tempKey:thisActivity.data.tempKey}})
                  // const activity = response.data.data.find((x:any) => x.data.start === null);
                  // if (activity.data.milestones && activity.data.milestones.length === 0) {
                  //   let milestoneToAdd = {
                  //       id: Number(activity.data.tempKey),
                  //       name: activity.data.name,
                  //       start: null,
                  //       end: null,
                  //       startDepth: 0,
                  //       endDepth: 0,
                  //       selectedOption: "Duration",
                  //       duration: 0,
                  //       code: activity.data.name,
                  //       dailyOperations: [],
                  //       description: "",
                  //       parentActivityId: activity.data.id
                  //   }
                  //   // Create the milestone using createMilestonesForActivity
                  //   HTTP.post('milestones/create', milestoneToAdd)
                  //   .then((res:any) => {
                  //     dispatch('updateNewMilestones',{data:res.data.data})
                  //       let tempActualKeyPairs = {id:res.data.data.id,tempId:res.data.data.tempKey}
                  //       resolve({changeType:"CREATE",tempActualKeyPairs})
                  //   })
                  //   .catch((error:any) => {
                  //       reject(error)
                  //   })
                  // }
                  
                  resolve(tempActualKeyPairs)
                }
                else {
                  reject('Unable to save');
                }
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve([])
        }
    })
  },

  updateActivitiesOnServer({dispatch,commit}:{dispatch:any,commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.activities.length>0){
            data.activities.forEach((item: any) => {
                if (item.operationUnitId === '') {
                  item.operationUnitId = undefined
                }
            });
            HTTP.put('activities/update',data)
            .then((reponse:any) => {
                dispatch('updateActivities',{sequenceId:data.sequenceId,projectId:data.projectId,data:reponse.data.data})
                resolve()
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve([])
        }
    })
  },
  
  deleteActivitiesOnServer({commit}:{commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.length>0){
            HTTP.post('activities/delete',data)
            .then((response:any) => {
                resolve(response)
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve()
        }
    })
  },

  fetchActivities({ commit } : { commit: any,state:IState},projectId:string){
    return new Promise((resolve, reject) => {
        HTTP.get('activities/?projectId=' + projectId)
        .then((response: any) => {
          commit('setActivities2', { activities: response.data.data });         
            resolve(response)                    
        })
        .catch((error: any) => {
            reject(error)
        })
    })
  },
  

  //server operations initilizer
  saveChanges({commit,dispatch,state,getters}:{commit:any,dispatch:any,state:IState,getters:any}){

    let creatOps:Array<any> = state.activityChanges.filter(thisEntry => thisEntry.action == "CREATE").map(thisEntry =>  getters.convertActivityToActivityModel(thisEntry.id))
    let updateOps:Array<any> = state.activityChanges.filter(thisEntry => thisEntry.action == "UPDATE").map(thisEntry => getters.convertActivityToActivityModel(thisEntry.id))
    let deleteOps:Array<any> = state.activityChanges.filter(thisEntry => thisEntry.action == "DELETE").map(thisEntry => thisEntry.id)

    let sequenceId = ""
    if(creatOps.length>0){
      sequenceId = creatOps[0].sequenceId
    }else{
      if(updateOps.length>0)sequenceId = updateOps[0].sequenceId
    }

    return new Promise((resolve,reject) => {
      dispatch("createActivitiesOnServer",{sequenceId,activities:creatOps,type:"List"}).then((tempActualKeyPairs:any) => {
          dispatch("updateActivitiesOnServer",{sequenceId,activities:updateOps,type:"List"}).then((updateRes:any) => {
              dispatch("deleteActivitiesOnServer",deleteOps).then((deleteRes:any) => {
                  resolve(tempActualKeyPairs)
              }).catch((error: any) => {
                reject('Failed to delete activity.')
              })
          }).catch((error: any) => {
            reject('Failed to update activity.')
          })
      }).catch((error: any) => {
        reject('Failed to create activity.')
      })
    })
    
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


